import { render, staticRenderFns } from "./skeleton-list.vue?vue&type=template&id=3e65165c&scoped=true&"
import script from "./skeleton-list.vue?vue&type=script&lang=ts&"
export * from "./skeleton-list.vue?vue&type=script&lang=ts&"
import style0 from "./skeleton-list.vue?vue&type=style&index=0&id=3e65165c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e65165c",
  null
  
)

export default component.exports